<div class="selected-obs">
    <div class="toolbar">
        <div class="g-just-flex flex-between">



            <div class="title">Selected observations {{selection.selected.length}}</div>
            <!--Add More Observations-->
            @if(editable) {
            <button mat-button (click)="addMore()" [disabled]="!editable">
                <mat-icon>add</mat-icon>
                Add more
            </button>
            }

        </div>

        @if (editable) {
        <div class="actions">
            <button mat-stroked-button (click)="deleteSelected()" [disabled]="selection.selected.length === 0">
                <mat-icon>delete</mat-icon>
                Delete selected
            </button>
        </div>
        }
    </div>

    <div class="table-wrap">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z1">

            <!-- Select Column -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="toggleAllRows()" [checked]="isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="selection.toggle(row)"
                        [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- Test Column -->
            <ng-container matColumnDef="test">
                <th mat-header-cell *matHeaderCellDef>Test</th>
                <td mat-cell *matCellDef="let row">{{ getTest(row) }}</td>
            </ng-container>

            <!-- Result Column -->
            <ng-container matColumnDef="result">
                <th mat-header-cell *matHeaderCellDef>Result</th>
                <td mat-cell *matCellDef="let row">{{ getResult(row) }}</td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let row">{{ getStatus(row) }}</td>
            </ng-container>

            <!-- Date Column -->
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let row">{{ getDate(row) }}</td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row" class="row-actions">
                    <button mat-icon-button (click)="deleteRow(row)" aria-label="Delete row">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: tableColumns" (click)="selection.toggle(row)"></tr>
        </table>

        @if (dataSource.data.length === 0) {
        <div class="empty">No observations.</div>
        }
    </div>
    <!-- @if(dialogRef){
    <div class="footer">
        <button mat-button (click)="close()">Close</button>
    </div>
    } -->
</div>